import { Select, SelectProps } from 'antd'
import React from 'react'
import { useCampaignFacebookLeadgenForms } from '../hooks'

export type CampaignLeadgenFormSelectProps = {
    accountId?: string | null
    campaignId?: string | null
} & SelectProps

export function CampaignLeadgenFormSelect({ campaignId, accountId, ...props }: CampaignLeadgenFormSelectProps) {
    const leadgenFormsQuery = useCampaignFacebookLeadgenForms(campaignId, accountId)

    return (
        <Select
            showSearch
            optionFilterProp="label"
            loading={leadgenFormsQuery.isPending}
            options={leadgenFormsQuery.data?.map(({ id, name }) => ({ value: id, label: name }))}
            {...props}
        />
    )
}
